import { DateTime } from 'luxon';

//yyyy-MM-ddを和暦に変換
export const getJapaneseYearText = (inputValue: string) => {
  if (DateTime.fromISO(inputValue).isValid) {
    let date;
    date = DateTime.fromISO(inputValue).toJSDate();
    return new Intl.DateTimeFormat('ja-JP-u-ca-japanese', { era: 'long', year: 'numeric' }).format(date);
  } else {
    return '';
  }
};
